<template>
  <div>
    <ul
      class="tablist"
      :class="{'tablist--inline': inline}"
    >
      <li
        v-for="(item, index) in items"
        :key="index"
        class="tablist__item"
        :class="{
          'tablist__item--selected': index == value
        }"
        @click="select(index)"
        @mouseover="hover = index"
        @mouseout="hover = null"
      >
        <slot
          :item="item"
          :index="index"
          :hover="hover === index"
          :selected="index === value"
        >
          {{ item }}
        </slot>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TabList',
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      hover: null,
    };
  },
  methods: {
    select(index) {
      this.$emit('input', index);
    },
  },
};
</script>

<style lang="scss" scoped>
.tablist {
    list-style: none;
    margin: 0;
    padding: 0;

    &--inline {
        display: flex;
        justify-content: center;
    }
    &__item {
        // opacity: 0.5;
        margin: 0 0.5rem;
        cursor: pointer;
        // transition: all 0.2s;
    }
    // &__item--selected,
    // &__item:hover {
    //     opacity: 1;
    //     text-decoration: underline;
    // }
}
</style>
